import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleTaskRemoval(
  state: State,
  task: Boundaries["removeTask"]["success"],
): State {
  return state.map((req) => ({
    ...req,
    calendar: {
      ...req.calendar,
      tasks: req.calendar.tasks.filter(({ uuid }) => task.uuid !== uuid),
    },
  }));
}

export { handleTaskRemoval };
